import React, { useState, useEffect } from "react";
import loginImg from "../assets/img/logo.png";
import { useParams, useNavigate } from "react-router-dom";

import store from "../catalog/app/redux/store";
import * as Actions from "../catalog/app/redux/actions";
import closeEyeImg from "../assets/img/closeEye.png";
import openEyeImg from "../assets/img/openEye.png";

import { Spin } from "antd";

const RefreshPwd = () => {
  let { token } = useParams();
  const [pwdOne, setPwdOne] = useState();
  const [pwdTwo, setPwdTwo] = useState();
  const [user, setUser] = useState();
  const [tokenExpirend, setTokenExpired] = useState();
  const [pwdError, setPwdError] = useState({ status: false, message: "" });
  const [showPwdOne, setShowPwdOne] = useState(false);
  const [showPwdTwo, setShowPwdTwo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [timer, setTimer] = useState(5 - 1);
  const navigate = useNavigate();

  useEffect(() => {
    store.dispatch(Actions.resetPwdToken(token)).then((data) => {

      if (data && data.type !== "ERROR_RESET_PWD_TOKEN") {
        const user = data.payload.data;
        setUser(user);
        setTokenExpired(false);
      } else {
        setTokenExpired(true);
      }
    });
  }, [token]);

  const validatePwds = (type, pwd) => {
    if (pwd && pwd.length < 10) {
      return setPwdError({
        status: true,
        message: "La contraseña debe tener al menos 10 caracteres.",
      });
    } else if (!/[A-Z]/.test(pwd)) {
      return setPwdError({
        status: true,
        message: "La contraseña debe tener al menos 1 carácter en mayúscula.",
      });
    } else if (!/[0-9]/.test(pwd)) {
      return setPwdError({
        status: true,
        message: "La contraseña debe tener al menos 1 número.",
      });
    } else if (!/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(pwd)) {
      return setPwdError({
        status: true,
        message: "La contraseña debe tener al menos 1 carácter especial.",
      });
    } else if (pwdOne !== pwdTwo) {
      return setPwdError({
        status: true,
        message: "La contraseña debe ser la misma en dos campos.",
      });
    } else {
      if (type === "pwdOne") {
        return setPwdError({ status: false, message: "" }), setPwdOne(pwd);
      } else {
        return setPwdError({ status: false, message: "" }), setPwdTwo(pwd);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!pwdError.status) {
      setLoading(true);
      store.dispatch(Actions.resetPwd(pwdOne, user)).then((data) => {
        const res = data.payload.data;

        if (res.message) {
          setPwdError({ status: true, message: res.message });
          setLoading(false);
        } else {
          setLoading(false);
          setSuccess(true);
        }
      });
    }
  };

  useEffect(() => {
    if (success) {
      const interval = setInterval(() => {
        setTimer((timer) => timer - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [success]);

  useEffect(() => {
    if (timer === 0) {
      navigate("/");
    }
  }, [timer === 0]);

  return (
    <div className="login">
      <div className="logo">
        <img src={loginImg}></img>
      </div>

      {success && (
        <div className="success">
          Gracias por usar nuestro sitio web, será redirigido a la página de
          inicio de sesión en un momento.<span>{timer}</span>
        </div>
      )}

      {tokenExpirend && !success && (
        <div className="token-expired">
          La solicitud de cambio de contraseña ha caducado.
        </div>
      )}

      {!tokenExpirend && !success && (
        <Spin spinning={loading}>
          <div className="content">
            <form onSubmit={(e) => handleSubmit(e)}>
              <div className="user-pwd">
                <input
                  type={showPwdOne ? "text" : "password"}
                  placeholder="Nueva contraseña"
                  onChange={(e) => setPwdOne(e.target.value)}
                  onBlur={(e) => validatePwds("pwdOne", pwdOne)}
                />
                <span className="hide-pw">
                  <span
                    className="dashicons dashicons-visibility"
                    onClick={() => setShowPwdOne(!showPwdOne)}
                  >
                    <img src={showPwdOne ? openEyeImg : closeEyeImg} />
                  </span>
                </span>
              </div>

              <div className="user-pwd">
                <input
                  type={showPwdTwo ? "text" : "password"}
                  placeholder="Confirmar contraseña"
                  onChange={(e) => setPwdTwo(e.target.value)}
                  onBlur={(e) => validatePwds("pwdTwo", pwdTwo)}
                />
                <span className="hide-pw">
                  <span
                    className="dashicons dashicons-visibility"
                    onClick={() => setShowPwdTwo(!showPwdTwo)}
                  >
                    <img src={showPwdTwo ? openEyeImg : closeEyeImg} />
                  </span>
                </span>
              </div>
              {pwdError.status && (
                <div className="error-status">{pwdError.message}</div>
              )}

              <p className="submit">
                <input type="submit" value="Enviar" />
              </p>
            </form>
          </div>
        </Spin>
      )}
    </div>
  );
};

export default RefreshPwd;
